import { useEffect, useRef } from 'react';
import gsap from 'gsap/all';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Container } from '@weareconceptstudio/core';

//* Styles
import BannerSectionStyle from './style';

//* Components
import StyledQuotedText from '@/components/StyledQuotedText';
import FileSection from '@/components/FileSection';
import Editor from '@/components/Editor';
import TitleAnim from '@/modules/_animation/Title';

gsap.registerPlugin(ScrollTrigger);

const BannerSection = ({ title, image, description }) => {
	//! Ref
	const titleRef = useRef();
	const triggerRef = useRef();
	const editorRef = useRef();
	const reverserTrigger = useRef();
	const fileRef = useRef();

	useEffect(() => {
		triggerRef.current = ScrollTrigger.create({
			start: 'top 80%',
			end: 'top top',
			trigger: titleRef.current,
			onEnter: () => {
				if (editorRef.current?.style?.opacity == 0) {
					if (editorRef.current && fileRef.current) {
						gsap.fromTo(editorRef.current, { opacity: 0 }, { opacity: 1, ease: 'power2.in', duration: 0.6, delay: 0.25 });

						gsap.fromTo(fileRef.current, { opacity: 0 }, { opacity: 1, duration: 0.6, ease: 'power2.in' });
						gsap.fromTo(fileRef.current, { y: '50%' }, { y: 0, duration: 0.6, ease: 'power2.out', delay: 0.1 });
					}
				}
			},
		});

		reverserTrigger.current = ScrollTrigger.create({
			start: 'top bottom',
			end: 'top top',
			trigger: titleRef.current,

			onLeaveBack: () => {
				if (editorRef.current && fileRef.current) {
					gsap.set(editorRef.current, { opacity: 0 });
					gsap.set(fileRef.current, { opacity: 0, y: '50%' });
				}
			},
		});

		return () => {
			if (triggerRef.current) {
				triggerRef.current.kill();
			}
			if (reverserTrigger.current) {
				reverserTrigger.current.kill();
			}
		};
	});
	return (
		<BannerSectionStyle className='banner-section'>
			<Container
				row
				className='banner-inner-section'
			>
				<div className='styled-text-wrapper col-12'>
					<div
						ref={titleRef}
						className='inner-wrap-title'
					>
						<TitleAnim load={true}>
							<StyledQuotedText text={title} />
						</TitleAnim>
					</div>
				</div>

				<div className='empty-col col-3 col-t-2 col-dx-1 col-m-12' />

				<div className='banner-editor col-6 col-t-8 col-dx-10 col-m-12'>
					<div
						ref={editorRef}
						className='opacity-zero'
					>
						<Editor data={description} />
					</div>
				</div>

				<div className='empty-col col-3 col-t-2 col-dx-1 col-m-12' />

				<div className='empty-col col-2 col-ds-1 col-t-12' />

				<div className='banner-file col-8 col-ds-10 col-t-12'>
					<div
						ref={fileRef}
						className='file-wrapper opacity-zero'
					>
						<FileSection file={image} />
					</div>
				</div>

				<div className='empty-col col-2 col-ds-1 col-t-12' />
			</Container>
		</BannerSectionStyle>
	);
};

export default BannerSection;
